export const getDomainNames = (url) => {
    try {
        // Asegura que la URL tenga http:// o https:// al inicio
        if (!/^https?:\/\//.test(url)) {
            url = 'https://' + url;
        }

        const parsedUrl = new URL(url);
        const hostname = parsedUrl.hostname;

        // Elimina 'www.' si está presente y separa el dominio por puntos
        const parts = hostname.replace(/^www\./, '').split('.');

        // Si el dominio tiene más de 2 partes (ej: tienda.jaypionba.com), toma el penúltimo (=> jaypionba)
        // Si tiene solo 2 partes (ej: jaypionba.com), toma el primero (=> jaypionba)
        return parts.length > 2 ? parts[parts.length - 2] : parts[0];
    } catch (error) {
        console.error('URL inválida:', url);
        return '';
    }
};
export const getDomainName = () => {
    try {
        // Toma automáticamente la URL actual del navegador
        const url = new URL(window.location.href);
        const hostname = url.hostname;

        // Elimina 'www.' si existe y divide por '.'
        const parts = hostname.replace(/^www\./, '').split('.');

        // Retorna el nombre base del dominio como arriba
        return parts.length > 2 ? parts[parts.length - 2] : parts[0];
    } catch (error) {
        console.error('URL inválida');
        return '';
    }
};
export const getMarcaNombre = () => {
    try {
        const domain = getDomainName(); // usa la función anterior
        const pathParts = window.location.pathname.split('/').filter(Boolean); // ['marca', 'nombre-marca']

        // Si el dominio es jaypionba o localhost, y la ruta empieza con /marca/...
        if ((domain === 'jaypionba' || domain === 'localhost') && pathParts[0] === 'marca' && pathParts[1]) {
            return pathParts[1]; // Devuelve solo 'nombre-marca'
        }

        return null;
    } catch (error) {
        console.error('Error al obtener nombre de marca:', error);
        return null;
    }
};


export const getSubdomain = () => {
    const host = window.location.hostname; // ejemplo: examples.jaypionba.com o www.examples.jaypionba.com
    const parts = host.split('.');

    // Si es tipo www.subdominio.dominio.com
    if (parts.length >= 3) {
        // si incluye 'www', lo ignoramos
        if (parts[0] === 'www') {
            return parts[1]; // www.examples.jaypionba.com -> examples
        }
        return parts[0]; // examples.jaypionba.com -> examples
    }

    return null; // no hay subdominio
};
